module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedExtraLightItalic.98498cc.eot";